import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import successIcon from 'src/assets/icons/statuses/success-active.svg'
import pendingIcon from 'src/assets/icons/statuses/pending-active.svg'
import inProgressIcon from 'src/assets/icons/statuses/in-progress-active.svg'
import failedIcon from 'src/assets/icons/statuses/failed-active.svg'
import successNotSelected from 'src/assets/icons/statuses/success-not-selected.svg'
import pendingNotSelected from 'src/assets/icons/statuses/pending-not-selected.svg'
import inProgressNotSelected from 'src/assets/icons/statuses/in-progress-not-selected.svg'
import failedNotSelected from 'src/assets/icons/statuses/failed-not-selected.svg'
import readyIcon from 'src/assets/icons/statuses/ready-icon.svg'
import readyNotSelected from 'src/assets/icons/statuses/ready-not-selected.svg'
import {
    FAILED,
    IN_PROGRESS,
    PENDING,
    SUCCESS,
    READY_FOR_EXECUTION,
} from 'src/store/modules/runbooks/actions'

import styles from './statusIcon.module.scss'

class StatusIcon extends Component {
    static propTypes = {
        status: PropTypes.oneOf([
            SUCCESS,
            PENDING,
            IN_PROGRESS,
            FAILED,
            READY_FOR_EXECUTION,
        ]),
        changeable: PropTypes.bool,
        notSelected: PropTypes.bool,
    }

    static defaultPropTypes = {
        changeable: false,
        notSelected: false,
    }


    getActiveIcon(status) {
        switch (status) {
            case SUCCESS:
                return { icon: successIcon, alt: 'success' }
            case PENDING:
                return { icon: pendingIcon, alt: 'pending' }
            case READY_FOR_EXECUTION:
                return { icon: readyIcon, alt: 'ready for execution' }
            case IN_PROGRESS:
                return { icon: inProgressIcon, alt: 'in progress' }
            case FAILED:
                return { icon: failedIcon, alt: 'failed' }
            default:
                return { icon: successIcon, alt: 'success' }
        }
    }


    getNotSelectedIcon(status) {
        switch (status) {
            case SUCCESS:
                return { icon: successNotSelected, alt: 'success not selected' }
            case PENDING:
                return { icon: pendingNotSelected, alt: 'pending not selected' }
            case READY_FOR_EXECUTION:
                return { icon: readyNotSelected, alt: 'ready for execution not selected' }
            case IN_PROGRESS:
                return {
                    icon: inProgressNotSelected,
                    alt: 'in progress not selected',
                }
            case FAILED:
                return { icon: failedNotSelected, alt: 'failed not selected' }
            default:
                return { icon: successNotSelected, alt: 'success not selected' }
        }
    }

    render() {
        const {
            status,
            changeable,
            notSelected,
            className,
            ...other
        } = this.props

        const icon = notSelected && changeable
            ? this.getNotSelectedIcon(status)
            : this.getActiveIcon(status)

        return (
            <img
                src={icon.icon}
                alt={icon.alt}
                className={classNames(className, {
                    [styles.icon]: changeable,
                    [styles.selectedIcon]: changeable && !notSelected,
                })}
                {...other}
            />
        )
    }
}

export default StatusIcon
